import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { RuleCommentModel, RuleModel } from '../model/rule.model';
import { RuleService } from '../service/rule.service';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AddComementRule } from '../state/action/rules.actions';
import { takeUntil } from 'rxjs/operators';
import { OrderDetailModel } from '../../state/model/order-detail.model';
import { QualityState } from '../../state/quality.state';
import { OverviewSubHeaderService } from '../../overview/sub-header/service/overview-sub-header.service';

@Component({
	selector: 'cv-rule-comment-create-component',
	templateUrl: './rule-comment-create.component.html',
	styleUrls: ['./rule-comment-create.component.scss']
})
export class RuleCommentCreateComponent implements OnDestroy {
	@Input() rule: RuleModel;
	@Input() isPhotoReview: boolean;
	@Output() cancel: EventEmitter<any> = new EventEmitter<any>();
	@Output() saved: EventEmitter<RuleCommentModel> = new EventEmitter<RuleCommentModel>();
	@Output() failed: EventEmitter<any> = new EventEmitter<any>();

	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);

	public comment: string;
	public linkToPhoto: boolean;
	public orderDetailModel: OrderDetailModel;
	public saving: boolean;

	get lockedBy(): any {
		return this.subheaderService.orderLocked;
	}

	private atComponentDestroy = new Subject();

	constructor(
		private ruleService: RuleService,
		private store: Store,
		private subheaderService: OverviewSubHeaderService
	) {
		this.orderDetail$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.orderDetailModel = orderDetailModel;
			});
		this.saving = false;
	}

	/**
	 * Creates the new comment.
	 */
	public addComment(): void {
		this.saving = true;
		const orderId = this.orderDetailModel.id;
		const documentId = this.orderDetailModel.documentId;
		this.ruleService
			.creatRuleComment(orderId, documentId, this.rule.name, this.comment)
			.subscribe({
				next: (response: any) => {
					if (response.isValid) {
						const notes = {
							id: response.key,
							note: this.comment,
							created: new Date(),
							updated: null,
							targets: [],
							vendor: false,
							createdBy: null
						};
						this.store.dispatch(new AddComementRule({ ruleName: this.rule.name, notes }));
						this.saved.emit(notes);
					} else {
						this.failed.emit();
					}
					this.saving = false;
				},
				error: (error: any) => {
					this.saving = false;
				}
			});
	}

	/**
	 * On Cancel/Close panel form.
	 */
	public onCancel(): void {
		this.cancel.emit();
	}

	/**
	 * On Comment keyup.
	 */
	public onCommentKeyUp(): void {
		if (this.comment.length && this.comment.trim() === '') {
			this.comment = this.comment.trim();
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
